import { render, staticRenderFns } from "./toolbar-surface.component.vue?vue&type=template&id=5166eef7&scoped=true&"
import script from "./toolbar-surface.component.vue?vue&type=script&lang=js&"
export * from "./toolbar-surface.component.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-surface.component.vue?vue&type=style&index=0&id=5166eef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5166eef7",
  null
  
)

export default component.exports